import React, { useEffect, useState } from 'react'
import { convertDateToString, discountedPrice, getBookingDate } from '../controller/control'
import Button from '@mui/material/Button';
import { createStore } from "../store/state"
import { useNavigate } from "react-router-dom"
import { IoIosCloseCircle } from "react-icons/io";
import { toast, Toaster } from "sonner"
import { useDispatch, useSelector } from "react-redux"
import { addToCart, getCartNumber, getCartList } from '../features/cartSlice';
import { nanoid } from '@reduxjs/toolkit';


export default function ProductCard({ product, bookingList }) {
    const [pageLoading, setPageLoading] = useState(false)
    const [modelOpen, setModelOpen] = useState(false)

    const [activeDate, setActiveDate] = useState("")
    const [selectedTime, setSelectedTime] = useState('')
    const [productId, setProductId] = useState("")

    const { user } = createStore((state) => state)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const cartCount = useSelector(getCartNumber)
    const cartList = useSelector(getCartList)

    const bookingDate = getBookingDate()
    const hours = ["10am", "11am", "12pm", "1pm", "2pm", "3pm", "4pm", "5pm", "6pm"]

    const handleModelOpen = (id) => {
        if (user) {
            setModelOpen(true)
            setProductId(id)
        }
        else {
            navigate('/login')
        }
    }

    const handleCurrentDate = (booking) => {
        setActiveDate(booking)
        setSelectedTime("")
    }

    const handleAddProduct = (product) => {
        if (!selectedTime || !activeDate) return toast.error("Select date and time")
        const isDateOnCart = cartList.find((item) => item.productId === productId && item.bookingDate === activeDate && item.time === selectedTime)

        if (isDateOnCart) {
            return toast.error("Item already on the cart")
        } else {
            dispatch(addToCart({
                ...product,
                id: nanoid(),
                productId: productId,
                bookingDate: activeDate,
                time: selectedTime
            }))

            toast.success("Date added on the cart")
        }
        setActiveDate()
        setSelectedTime()
    }

    const checkAll = bookingList.filter((t) => t.productId === productId && convertDateToString(t.bookingDate) === activeDate)
    const checkTime = (time) => {
        const bookedTime = checkAll.find((item) => convertDateToString(item.bookingDate) === activeDate && item.time === time && item.isBooked === true)
        return bookedTime
    }

    useEffect(() => {
        setPageLoading(true)
    }, [checkAll])

    return (
        <>
            <Toaster richColors position="top-center" />
            <div className='product-details'>
                <img src={product.productImgUrl} alt={product.title} />
                <h3>{product.title}</h3>
                <div className='offer-price'>
                    Sale: {product.discount}%
                </div>
                <p><span className='line-through'>Rs. {product.price}</span> Rs. {discountedPrice(product.price, product.discount)} </p>
                <div className='button-manage'>
                    <Button variant="contained" size='small' color='error' onClick={() => handleModelOpen(product._id)}>
                        Book Now
                    </Button>
                </div>
            </div>
            {modelOpen && <div className='modal-booking'>
                <div className='modal-details'>
                    <IoIosCloseCircle onClick={() => setModelOpen(false)} size="32" className='model-close' />
                    <h3>Select your Booking date</h3>
                    <div className='modal-header'>
                        <div>
                            <img src={product.productImgUrl} alt={product.title} />
                        </div>
                        <div>
                            <h4>{product.title}</h4>
                        </div>
                        <div>
                            <span className='line-through'>Rs. {product.price}</span> Rs. {discountedPrice(product.price, product.discount)}
                        </div>
                    </div>
                    <div className='date-picker'>
                        {bookingDate.map((booking, i) => <div className={`date-pick ${activeDate === booking ? "picked" : ""}`} key={i} onClick={() => handleCurrentDate(booking)}><span>{booking.slice(0, -12)}</span><br />{booking.slice(8, -5)}</div>)}
                    </div>
                    <div className='time-list'>
                        {checkAll.length > 0 ?
                            <>
                                {hours.map((hour) => <span key={hour} onClick={() => setSelectedTime(hour)} className={`book-hour ${checkTime(hour) ? "booked-time" : ""} ${selectedTime === hour ? "time-selected" : ""}`}>{hour}</span>)}
                            </>
                            : <>
                                {hours.map((hour) => <span key={hour} onClick={() => setSelectedTime(hour)} className={`book-hour ${selectedTime === hour ? "time-selected" : ""} `}>{hour}</span>)}
                            </>
                        }
                    </div>
                    <Button variant="contained" type='submit' size='small' color='error' onClick={() => handleAddProduct(product)}>
                        Add to cart
                    </Button>
                </div>
            </div>}
        </>
    )
}
